// Markdown-It plugin: convert autolinked bare image URLs into <img> tags
// Example: typing https://example.com/pic.png becomes an image in preview.

const IMG_EXT_RE = /\.(png|jpe?g|gif|webp|bmp|svg)(\?.*)?$/i

export function markdownItAutoImage(md) {
  md.core.ruler.after('linkify', 'auto_image', (state) => {
    const tokens = state.tokens
    for (let i = 0; i < tokens.length; i++) {
      const block = tokens[i]
      if (!block || block.type !== 'inline' || !block.children) continue
      const children = block.children
      for (let j = 0; j < children.length; j++) {
        const t = children[j]
        if (t.type === 'link_open') {
          const open = t
          const text = children[j + 1]
          const close = children[j + 2]
          if (!open || !text || !close) continue
          if (text.type !== 'text' || close.type !== 'link_close') continue
          const hrefAttr = open.attrs && open.attrs.find((a) => a[0] === 'href')
          const href = hrefAttr ? hrefAttr[1] : ''
          if (!href || !IMG_EXT_RE.test(href)) continue
          // Replace triplet link_open, text, link_close with a single image token
          try {
            // Always use raw HTML to avoid default image renderer path
            const Token = state.Token
            const html = `<img src="${href}" alt="${(text.content || '').replace(
              /"/g,
              '&quot;'
            )}" loading="lazy">`
            if (Token) {
              const htmlToken = new Token('html_inline', '', 0)
              htmlToken.content = html
              children.splice(j, 3, htmlToken)
            } else {
              // As last resort, leave the link as-is
            }
          } catch {
            // As a last resort, leave the link as-is
          }
        }
      }
    }
  })
}

export default markdownItAutoImage
